import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap, delay } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../services/auth.service";
import { RolesUsersEnum } from "../enum/roles-users.enum";
import { Router } from "@angular/router";
import { TogglesValidation } from "../../core/helpers/toggles";
import { TogglesConfiguration } from "../../core/enum/toggles-configuration.enum";
import { LocalStorage } from "src/app/core/helpers/local-storage";
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private timer: number = 60 * 1000 * 30;
  constructor(
    private authenticationService: AuthenticationService,
    private route: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const hasToggleSelectApi = TogglesValidation.toggleShow(TogglesConfiguration.SELECT_API_AT_LOGIN);
    const apiUrl = hasToggleSelectApi ? LocalStorage.getItem("apiManualByLogin") || environment.apiUrl : environment.apiUrl;
    if (request.url.startsWith(apiUrl)) {
      const token = this.authenticationService.getBearerToken();
      const user = this.authenticationService.getCurrentUser();
      this.inactivity(this.timer);

      if (user) {
        if (!user) {
          const breakLogin = !user.accept_terms && user.roles !== RolesUsersEnum.ADMIN && this.route.url !== "/login";
          if (!user || breakLogin) {
            this.authenticationService.logout();
          }
        }
      }

      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: token
          }
        });
      }

      if (!token) {
        request = request.clone({
          setHeaders: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        });
      }
    }

    return next.handle(request);
  }

  /**
   * @description Observa a Inatividade do usuario e encerra a sessao.
   * @param timer  time in miliseconds
   */
  private inactivity(timer: number) {
    of([])
      .pipe(
        delay(timer),
        tap(() => {
          this.authenticationService.logout();
          window.location.reload();
        })
      )
      .subscribe();
  }
}
